// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1febdb4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Panel/Panel.vue
// module id = 14
// module chunks = 0